import SkeletonTable from "@/components/SkeletonTable";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { useTahun } from "@/hooks/useTahun";

const getListRekapBerkasPasca = async (
  idsSysPeriodeParams: string,
  tahunParams: string,
) => {
  const response = await api.get(
    `/operator-pasca/verifikator-berkas/index?ids_sys_periode=${idsSysPeriodeParams}&tahun=${tahunParams}`,
    {
      withCredentials: true,
    },
  );
  return response.data;
};

export default function SettingVerifikatorPascaPage() {
  const [searchParams] = useSearchParams();
  const idsSysPeriodeParams = searchParams.get("ids_sys_periode") || "";
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: [
      "listRekapBerkasPasca",
      idsSysPeriodeParams,
      selectedTahun?.label,
    ],
    queryFn: () =>
      getListRekapBerkasPasca(idsSysPeriodeParams, selectedTahun.label),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  );
}
